
<div class="container-fluid">
  <template v-if="fromDetailView">
    <detail-view-content-element-header
      :content-element="headerComponent"
      :object-model-entry="selectedObjectModelEntry"
      :hide-tabs="true"
    ></detail-view-content-element-header>
    <div class="container">
      <br>
      <h2>{{embeddedListViewTitle}}</h2>
      <hr>
    </div>
  </template>
  <div v-else class="container">
    <br>
    <h2>{{targetListView.titleOrDefault}}</h2>
    <hr>
  </div>
  <div v-if="showDescription" class="container" id="short-description">
    <div v-html="targetListView.short_description" class="fr-view"></div>
    <hr>
  </div>
  <div class="module-alt">
    <flash></flash>
    <list-view-table
      v-if="targetListView"
      :list-view="targetListView"
      :preview="preview"
      :opts="tableOpts"
    ></list-view-table>
  </div>
</div>
